import { FC, useState } from 'react';
import {
  faCartFlatbedSuitcase,
  faPersonWalkingLuggage,
  faSuitcaseRolling,
} from '@fortawesome/free-solid-svg-icons';
import TicketBaggagePopup from './TicketBaggagePopup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import withErrorBoundary from 'components/shared/withErrorBoundary';

interface TicketBaggageProps {
  bound: any;
}

const TickteBaggage: FC<TicketBaggageProps> = ({ bound }) => {
  const [showDetails, setShowDetails] = useState(false);
  const { t } = useTranslation();

  const isRedHandbag =
    !bound.listOfFlyBaggagePrice || bound.listOfFlyBaggagePrice?.[0]?.maxWeightHandbag === 0;
  const isRedTrolley =
    !bound.listOfFlyBaggagePrice || bound.listOfFlyBaggagePrice?.[0]?.maxWeightTrolley === 0;
  const isGreenTotal =
    bound.listOfFlyBaggagePrice &&
    (bound.listOfFlyBaggagePrice?.[0]?.maxTotalWeight > 0 ||
      bound.listOfFlyBaggagePrice?.[0]?.pieces > 0);

  return (
    <div
      className="ticket-baggage"
      onMouseEnter={() => setShowDetails(true)}
      onMouseLeave={() => setShowDetails(false)}
    >
      {bound.listOfFlyBaggagePrice?.[0]?.maxWeightHandbag !== -1 && (
        <div>
          <FontAwesomeIcon
            icon={faSuitcaseRolling}
            className={isRedHandbag ? 'color-danger' : 'text-success'}
          />
          {isRedHandbag ? (
            <span className="color-danger">{t('flight.handbag_excluded')}</span>
          ) : (
            <span className="text-success">{t('flight.handbag_included')}</span>
          )}
        </div>
      )}

      {bound.listOfFlyBaggagePrice?.[0]?.maxWeightTrolley !== -1 && (
        <div>
          <FontAwesomeIcon
            icon={faPersonWalkingLuggage}
            className={isRedTrolley ? 'color-danger' : 'text-success'}
          />
          {isRedTrolley ? (
            <span className="color-danger">{t('flight.trolley_excluded')}</span>
          ) : (
            <span className="text-success">{t('flight.trolley_included')}</span>
          )}
        </div>
      )}

      {bound.listOfFlyBaggagePrice?.[0]?.maxTotalWeight !== -1 && (
        <div>
          <FontAwesomeIcon
            icon={faCartFlatbedSuitcase}
            className={isGreenTotal ? 'text-success' : 'color-danger'}
          />
          {isGreenTotal ? (
            <span className="text-success">{t('flight.bag_included')}</span>
          ) : (
            <span className="color-danger">{t('flight.bag_excluded')}</span>
          )}
        </div>
      )}

      {showDetails && <TicketBaggagePopup outbond={bound as any} />}
    </div>
  );
};

export default withErrorBoundary(TickteBaggage, 'TickteBaggage');
